import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from './client'

export interface MarketplaceAccountStatus {
  key: string
  platform: 'ebay' | 'amazon' | 'kaufland' | 'metro' | 'shopify'
  label: string
  company: 'Stahlia' | 'DRS' | 'Neuhall'
  expected_identity: string
  identity: string | null
  status: 'nicht_eingerichtet' | 'fehler' | 'warnung' | 'aktiv' | null
  access_ok: boolean
  error_code: string | null
  message: string
  missing_env: string[]
  deadline_at: string | null
  deadline_kind: 'ebay_refresh_token' | 'amazon_client_secret' | null
  checked_at: string | null
  last_ok_at: string | null
  stale: boolean
}
export interface MarketplaceAccountsResponse {
  accounts: MarketplaceAccountStatus[]
  takt_enabled: boolean
  backend_started_at: string
}

export function useMarketplaceAccounts(enabled: boolean) {
  return useQuery({
    queryKey: ['marketplace-accounts'],
    queryFn: () => api.get<MarketplaceAccountsResponse>('/marketplace-accounts/'),
    enabled, refetchInterval: 60000,
  })
}

export function useCheckMarketplaceAccount() {
  const client = useQueryClient()
  return useMutation({
    mutationFn: (key: string) => api.post(`/marketplace-accounts/${encodeURIComponent(key)}/check/`),
    onSuccess: () => client.invalidateQueries({ queryKey: ['marketplace-accounts'] }),
  })
}
